import axios from "axios";
import CheckHttp from "@/asyncs/MyHttpCheck.js";
import {
    Notify
} from "vant";
import Env from "@/logics/Envs.js";

export default async function (classIds, propName) {
    try {
        const toSend = new FormData();
        toSend.append("classIds", JSON.stringify(classIds));
        toSend.append("propName", propName);
        const res = await axios.post(Env.apiPath + "listClassProp", toSend);
        if (res.data.error) {
            Notify({
                type: "danger",
                message: res.data.error,
                duration: 5000
            });
            return null;
        }
        return res.data.dict;
    } catch (err) {
        CheckHttp(err);
        return null;
    }
}